"use client";

import { Text, TextLink } from "./catalyst/text";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import { Button } from "./catalyst/button";
import posthog from "posthog-js";

export function CookieBanner() {
  const t = useTranslations("CookieBanner");
  const [consentGiven, setConsentGiven] = useState("");

  useEffect(() => {
    // We want this to only run once the client loads
    // or else it causes a hydration error

    // eslint-disable-next-line react-hooks/set-state-in-effect
    setConsentGiven(posthog.get_explicit_consent_status());
  }, []);

  const handleAcceptCookies = () => {
    posthog.opt_in_capturing();
    setConsentGiven("granted");
  };

  const handleDeclineCookies = () => {
    posthog.opt_out_capturing();
    setConsentGiven("denied");
  };

  if (consentGiven !== "pending") {
    return null;
  }

  return (
    <div
      className="pointer-events-none fixed inset-x-0 bottom-0 px-6 pb-6"
      data-testid="cookie-banner"
    >
      <div className="pointer-events-auto mx-auto max-w-xl rounded-xl bg-white p-6 shadow-lg outline-1 outline-gray-900/10 dark:bg-stone-950 dark:shadow-none dark:-outline-offset-1 dark:outline-white/10">
        <Text>
          {t.rich("message", {
            cookiePolicy: (chunks) => (
              <TextLink href="/privacy">{chunks}</TextLink>
            ),
          })}
        </Text>
        <div className="mt-8 flex items-center gap-x-5">
          <Button onClick={handleAcceptCookies} color="purple">
            {t("acceptAll")}
          </Button>
          <Button
            onClick={handleDeclineCookies}
            plain
            data-testid="cookie-reject-button"
          >
            {t("rejectAll")}
          </Button>
        </div>
      </div>
    </div>
  );
}
